// src/pages/Convocations/components/ConvocationSupportBadges.jsx

import React from "react";

import {
  FaBed,
  FaTrain,
} from "react-icons/fa";

import { getSupportStatusLabel } from "../utils/convocation.utils";

export default function ConvocationSupportBadges({
  convocation,
}) {
  const hasTransport =
    convocation
      ?.need_transport_support ===
    true;

  const hasAccommodation =
    convocation
      ?.need_accommodation_support ===
    true;

  if (
    !hasTransport &&
    !hasAccommodation
  ) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-2">
      {hasTransport ? (
        <span
          className="
            inline-flex items-center gap-1.5
            rounded-full
            border border-sky-200
            bg-sky-50
            px-2.5 py-1
            text-[11px] font-black
            text-sky-700
            dark:border-sky-800
            dark:bg-sky-950/40
            dark:text-sky-300
          "
        >
          <FaTrain />

          Transport

          {convocation
            .transport_support_status ? (
            <span className="opacity-75">
              ·{" "}
              {getSupportStatusLabel(
                convocation
                  .transport_support_status,
              )}
            </span>
          ) : null}
        </span>
      ) : null}

      {hasAccommodation ? (
        <span
          className="
            inline-flex items-center gap-1.5
            rounded-full
            border border-violet-200
            bg-violet-50
            px-2.5 py-1
            text-[11px] font-black
            text-violet-700
            dark:border-violet-800
            dark:bg-violet-950/40
            dark:text-violet-300
          "
        >
          <FaBed />

          Hébergement

          {convocation
            .accommodation_support_status ? (
            <span className="opacity-75">
              ·{" "}
              {getSupportStatusLabel(
                convocation
                  .accommodation_support_status,
              )}
            </span>
          ) : null}
        </span>
      ) : null}
    </div>
  );
}